export const SET_MAIN_CONFIG = "SET_MAIN_CONFIG";
export const SET_AUX_VALUE = "SET_AUX_VALUE";
export const SET_QUANTITY = "SET_QUANTITY";
